import { number, mixed } from "yup";

export const int = number().integer();

export const uint = int.positive();

export const OneOf = <T>(values: T[]) => {
  return mixed<typeof values[0]>().oneOf(values);
}
